import { io } from "socket.io-client";

// The live spectate socket lives on the LITE server (realtime host), not the
// pro REST server the axios client uses — mirrors the mobile app's split
// (tarbaa-pro-app src/apis/index.js BASE_URL vs OLD_URL).
const LITE_URL = "https://tarbaa-lite.apis.just2labs.com";
// const LITE_URL = "http://localhost:8080";

/**
 * Connect to the anonymous /spectate namespace for one session.
 * identity = { viewerId, name, teamId } from localStorage (all optional) —
 * lets a refreshed tab rejoin the same locked team, even after a server
 * restart lost the in-memory roster.
 */
export const createSpectateSocket = (code, identity = {}) =>
  io(`${LITE_URL}/spectate`, {
    auth: {
      code,
      viewerId: identity.viewerId || undefined,
      name: identity.name || undefined,
      teamId: identity.teamId || undefined,
    },
  });

/**
 * Socket for the WEB game master. Web games need no login, so the GM also
 * lives on /spectate: `gm: "create"` lets the handshake through without a
 * session code, and every gm:* event is authorized by the per-session gmKey
 * issued at gm:create.
 */
export const createGmSocket = () =>
  io(`${LITE_URL}/spectate`, { auth: { gm: "create" } });
